import { selectNumCaseUploads } from "@/store/slices/casesSlice";
import { selectIsUploading } from "@/store/slices/caseUploadsSlice";
import { RootState } from "@/store/store";
import { useEffect } from "react";
import { useSelector } from "react-redux";

export const usePreventNavigationWhileUploading = () => {
  const isUploading = useSelector((state: RootState) => selectNumCaseUploads(state) !== 0 || selectIsUploading(state));

  // Warn user before closing/refreshing browser tab when cases are uploading
  useEffect(() => {
    const unloadCallback = (event: BeforeUnloadEvent) => {
      if (isUploading) {
        event.preventDefault();
        event.returnValue = "";
        return "";
      }

      event.returnValue = false;
      return false;
    };

    if (isUploading) {
      window.addEventListener("beforeunload", unloadCallback);
    } else {
      window.removeEventListener("beforeunload", unloadCallback);
    }

    return () => window.removeEventListener("beforeunload", unloadCallback);
  }, [isUploading]);

  return;
};
